import './Header.css'

const Header = () => {
    
    return (
        <>
            <header>
                <nav>
                <h3 style={{color:'red'}}>Spectacles Shop</h3>
                    <h3>Buy your <span>Spectacles</span> from us</h3>
                </nav>
            </header>
            
        </>
    );
};

export default Header;